// eslint-disable-next-line no-unused-vars
import React from 'react';
import { withRouter } from 'react-router-dom';

const PublicLayout = ({ children }) => children;

export default withRouter(PublicLayout);
